<template>
  <div class="pdf-statement">
    <v-container>
      <v-card>
        <v-card-title class="headline">
          <v-icon left>mdi-file-document-outline</v-icon>
          ระบบสร้าง Statement (ใบแจ้งหนี้ทนายความ)
        </v-card-title>

        <v-card-text>
          <!-- ข้อมูลบริษัท/สำนักงาน -->
          <v-row>
            <v-col cols="12">
              <h3 class="mb-3">ข้อมูลสำนักงาน</h3>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.companyName"
                label="ชื่อสำนักงาน (อังกฤษ)"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.companyNameThai"
                label="ชื่อสำนักงาน (ไทย)"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.companyType"
                label="ประเภท (ATTORNEYS AT LAW)"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.taxId"
                label="TAX ID. No."
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="statement.address"
                label="ที่อยู่สำนักงาน"
                outlined
                rows="4"
                dense
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="statement.phone"
                label="เบอร์โทรศัพท์"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="statement.email"
                label="อีเมล"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- ข้อมูลลูกค้า -->
          <v-row>
            <v-col cols="12">
              <h3 class="mb-3">ข้อมูลลูกค้า</h3>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.clientName"
                label="ชื่อลูกค้า"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.clientTaxId"
                label="TAX ID ลูกค้า"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="statement.clientAddress"
                label="ที่อยู่ลูกค้า"
                outlined
                rows="3"
                dense
              ></v-textarea>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- ข้อมูลเอกสาร -->
          <v-row>
            <v-col cols="12">
              <h3 class="mb-3">ข้อมูลเอกสาร</h3>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="statement.documentNo"
                label="เลขที่เอกสาร"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="statement.date"
                label="วันที่"
                type="date"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="statement.attention"
                label="Attention"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.periodCovered"
                label="Period Covered / รอบระยะเวลา"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="statement.documentRef"
                label="Document Ref."
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- รายการบริการ -->
          <v-row>
            <v-col cols="12">
              <h3 class="mb-3">รายการค่าบริการ</h3>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="statement.serviceDescription"
                label="รายละเอียดบริการ"
                outlined
                rows="8"
                dense
                placeholder="TO OUR CHARGES for professional service rendered to..."
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="statement.amount"
                label="จำนวนเงิน"
                type="number"
                outlined
                dense
                prefix="฿"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="statement.withholdingTaxPercent"
                label="ภาษี ณ ที่จ่าย (%)"
                type="number"
                outlined
                dense
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="statement.vatPercent"
                label="VAT (%)"
                type="number"
                outlined
                dense
                suffix="%"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- คำเตือนและหมายเหตุ -->
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="statement.importantNote"
                label="IMPORTANT Note"
                outlined
                rows="3"
                dense
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="statement.disclaimer"
                label="Disclaimer"
                outlined
                rows="3"
                dense
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- สรุปยอด -->
          <v-row class="mt-4">
            <v-col cols="12" class="text-right">
              <div class="summary-box">
                <p>
                  <strong>Sub Total / รวมเป็นเงิน:</strong>
                  {{ formatNumber(statement.amount) }} ฿
                </p>
                <p>
                  <strong>Less Withholding Tax:</strong>
                  {{ formatNumber(withholdingTax) }} ฿
                </p>
                <p>
                  <strong>Add VAT {{ statement.vatPercent }}%:</strong>
                  {{ formatNumber(vat) }} ฿
                </p>
                <p class="total">
                  <strong>Grand Total / ยอดรวม:</strong>
                  {{ formatNumber(grandTotal) }} ฿
                </p>
                <p class="text-caption">{{ numberToText(grandTotal) }}</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            large
            :disabled="!pdfMakeReady"
            @click="previewPDF"
          >
            <v-icon left>mdi-eye</v-icon>
            ดูตัวอย่าง PDF
          </v-btn>
          <v-btn
            color="success"
            large
            :disabled="!pdfMakeReady"
            @click="downloadPDF"
          >
            <v-icon left>mdi-download</v-icon>
            ดาวน์โหลด PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :value="!pdfMakeReady">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
      <p class="mt-3 white--text">กำลังโหลดระบบ PDF...</p>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "TestPDFMake",

  data() {
    return {
      pdfMakeReady: false,
      statement: {
        // ข้อมูลบริษัท
        companyName: "DEJ-UDOM & ASSOCIATES",
        companyNameThai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
        companyType: "ATTORNEYS AT LAW",
        taxId: "0992000028227",
        address:
          "CHARN ISSARA TOWER 1, 2nd FLOOR,\n942/69 RAMA IV ROAD,\nKWAENG SURIYAWONG, KHET BANGRAK,\nBANGKOK 10500, THAILAND",
        phone: "Tel : 0-2233-0055, 0-2267-5152",
        email: "E-MAIL : account@dejudom.com",

        // ข้อมูลลูกค้า
        clientName: "ALPHATECH SEMICONDUCTOR",
        clientTaxId: "0 / -",
        clientAddress: "ddddddddddddddddd bangkok , 10150 Thailand",

        // ข้อมูลเอกสาร
        documentNo: "L25100004",
        date: "2025-10-17",
        attention: "- / null",
        periodCovered: "-",
        documentRef: ":-",

        // รายการบริการ
        serviceDescription:
          "TO OUR CHARGES for professional service rendered to ALPHATECH SEMICONDUCTOR in connection with",
        amount: 500.0,
        withholdingTaxPercent: 0.0,
        vatPercent: 7.0,

        // หมายเหตุ
        importantNote:
          "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes; we will solely be responsible for Thai tax.",
        disclaimer:
          "Cybersecurity & Wire Transfer Disclaimer\n\nDej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must independently be verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt.",
      },
    };
  },

  computed: {
    withholdingTax() {
      return (
        this.statement.amount * (this.statement.withholdingTaxPercent / 100)
      );
    },
    vat() {
      return this.statement.amount * (this.statement.vatPercent / 100);
    },
    grandTotal() {
      return this.statement.amount - this.withholdingTax + this.vat;
    },
  },

  mounted() {
    this.waitForPdfMake();
    this.$hideLoader();
  },

  methods: {
    waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert("ไม่สามารถโหลดระบบ PDF ได้");
        }
      }, 10000);
    },

    formatNumber(number) {
      return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    numberToText(num) {
      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];
      const teens = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const numToWords = (n) => {
        if (n === 0) return "Zero";
        if (n < 10) return ones[n];
        if (n < 20) return teens[n - 10];
        if (n < 100)
          return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        if (n < 1000)
          return (
            ones[Math.floor(n / 100)] +
            " Hundred" +
            (n % 100 ? " " + numToWords(n % 100) : "")
          );
        return n.toString();
      };

      const intPart = Math.floor(num);
      const decPart = Math.round((num - intPart) * 100);

      let result = numToWords(intPart);
      if (decPart > 0) {
        result += " Point " + numToWords(decPart);
      }
      return `(${result})`;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    generateDocDefinition() {
      return {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],

        content: [
          // Header - ชื่อบริษัท
          {
            text: this.statement.companyName,
            style: "companyName",
            alignment: "center",
          },
          {
            text: this.statement.companyType,
            style: "companyType",
            alignment: "center",
            margin: [0, 2, 0, 0],
          },
          {
            text: this.statement.companyNameThai,
            style: "companyNameThai",
            alignment: "center",
            margin: [0, 3, 0, 0],
          },
          {
            text: this.statement.address,
            style: "address",
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          {
            text: this.statement.phone,
            style: "contact",
            alignment: "center",
            margin: [0, 3, 0, 0],
          },
          {
            text: this.statement.email,
            style: "contact",
            alignment: "center",
            margin: [0, 2, 0, 0],
          },
          {
            text: `TAX ID. No. ${this.statement.taxId}/ "HEAD OFFICE"`,
            style: "contact",
            alignment: "center",
            margin: [0, 2, 0, 15],
          },

          // STATEMENT Title
          {
            columns: [
              { width: "*", text: "" },
              {
                width: "auto",
                stack: [
                  {
                    text: "STATEMENT",
                    style: "statementTitle",
                  },
                ],
              },
              {
                width: 100,
                stack: [
                  {
                    text: "ORIGINAL",
                    style: "originalMark",
                    alignment: "right",
                  },
                  {
                    text: `No. / เลขที่ : ${this.statement.documentNo}`,
                    style: "docNumber",
                    alignment: "right",
                    margin: [0, 2, 0, 0],
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 15],
          },

          // ข้อมูลลูกค้าและวันที่
          {
            columns: [
              {
                width: "55%",
                stack: [
                  {
                    text: [
                      { text: "To/ถึง :     ", style: "label" },
                      { text: this.statement.clientName, style: "value" },
                    ],
                  },
                  {
                    text: `               ${this.statement.clientAddress}`,
                    style: "value",
                    margin: [0, 2, 0, 10],
                  },
                  {
                    text: [
                      { text: "TAX ID :    ", style: "label" },
                      { text: this.statement.clientTaxId, style: "value" },
                    ],
                  },
                ],
              },
              {
                width: "45%",
                stack: [
                  {
                    text: [
                      { text: "Date/วันที่ : ", style: "label" },
                      {
                        text: this.formatDate(this.statement.date),
                        style: "value",
                      },
                    ],
                    alignment: "left",
                  },
                  {
                    text: [
                      {
                        text: "Period Covered / รอบระยะเวลา :    ",
                        style: "label",
                      },
                      { text: this.statement.periodCovered, style: "value" },
                    ],
                    margin: [0, 2, 0, 0],
                  },
                  {
                    text: [
                      { text: "Attention :   ", style: "label" },
                      { text: this.statement.attention, style: "value" },
                    ],
                    margin: [0, 2, 0, 10],
                  },
                  {
                    text: [
                      { text: "Document Ref. ", style: "label" },
                      { text: this.statement.documentRef, style: "value" },
                    ],
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 15],
          },

          // ตารางรายการ
          {
            table: {
              widths: ["*", 100],
              body: [
                [
                  { text: "Description / รายการ", style: "tableHeader" },
                  {
                    text: "Amount / จำนวนเงิน",
                    style: "tableHeader",
                    alignment: "right",
                  },
                ],
                [
                  {
                    stack: [
                      {
                        text: this.statement.serviceDescription,
                        style: "description",
                        margin: [5, 10, 5, 300],
                      },
                      {
                        text: this.statement.importantNote,
                        style: "important",
                        margin: [5, 0, 5, 10],
                      },
                    ],
                  },
                  {
                    text: this.formatNumber(this.statement.amount),
                    style: "amount",
                    alignment: "right",
                    margin: [5, 10, 5, 0],
                  },
                ],
                [
                  { text: "Sub Total / รวมเป็นเงิน", style: "subtotalLabel" },
                  {
                    text: this.formatNumber(this.statement.amount),
                    style: "subtotalAmount",
                    alignment: "right",
                  },
                ],
                [
                  {
                    text: `Less Withholding Tax / ภาษีเงินได้ หัก ณ ที่จ่าย (${this.formatNumber(
                      this.statement.withholdingTaxPercent
                    )} %)`,
                    style: "subtotalLabel",
                  },
                  {
                    text: this.formatNumber(this.withholdingTax),
                    style: "subtotalAmount",
                    alignment: "right",
                  },
                ],
                [
                  {
                    text: "Grand Total / ยอดรวม",
                    style: "grandTotalLabel",
                    bold: true,
                  },
                  {
                    text: this.formatNumber(this.grandTotal),
                    style: "grandTotalAmount",
                    alignment: "right",
                    bold: true,
                  },
                ],
                [
                  {
                    text: this.numberToText(this.grandTotal),
                    style: "amountText",
                    alignment: "center",
                    colSpan: 2,
                  },
                  {},
                ],
              ],
            },
            layout: {
              hLineWidth: function(i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 1
                  : 0.5;
              },
              vLineWidth: function() {
                return 1;
              },
            },
          },

          // หมายเหตุใต้ตาราง
          {
            text:
              "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
            style: "note",
            alignment: "center",
            margin: [0, 10, 0, 3],
          },
          {
            text:
              "โปรดส่งหนังสือรับรองภาษีหักภาษี ณ ที่จ่ายมาพร้อมกับเงินค่าบริการระงเงิน",
            style: "noteThai",
            alignment: "center",
            margin: [0, 0, 0, 15],
          },

          // Disclaimer
          {
            text: "Cybersecurity & Wire Transfer Disclaimer",
            style: "disclaimerTitle",
            color: "red",
            margin: [0, 0, 0, 5],
          },
          {
            text: this.statement.disclaimer,
            style: "disclaimerText",
            color: "red",
          },
        ],

        styles: {
          companyName: {
            fontSize: 16,
            bold: true,
          },
          companyType: {
            fontSize: 11,
            bold: true,
          },
          companyNameThai: {
            fontSize: 13,
            bold: true,
          },
          address: {
            fontSize: 9,
          },
          contact: {
            fontSize: 9,
          },
          statementTitle: {
            fontSize: 20,
            bold: true,
          },
          originalMark: {
            fontSize: 11,
            bold: true,
          },
          docNumber: {
            fontSize: 10,
          },
          label: {
            fontSize: 10,
            bold: false,
          },
          value: {
            fontSize: 10,
          },
          tableHeader: {
            fontSize: 11,
            bold: true,
            fillColor: "#ffffff",
          },
          description: {
            fontSize: 10,
          },
          important: {
            fontSize: 9,
            bold: true,
          },
          amount: {
            fontSize: 11,
          },
          subtotalLabel: {
            fontSize: 10,
            bold: true,
          },
          subtotalAmount: {
            fontSize: 10,
          },
          grandTotalLabel: {
            fontSize: 11,
            bold: true,
          },
          grandTotalAmount: {
            fontSize: 11,
            bold: true,
          },
          amountText: {
            fontSize: 9,
            italics: true,
          },
          note: {
            fontSize: 9,
          },
          noteThai: {
            fontSize: 9,
          },
          disclaimerTitle: {
            fontSize: 10,
            bold: true,
          },
          disclaimerText: {
            fontSize: 8,
          },
        },

        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
    },

    previewPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        pdfMake.createPdf(docDefinition).open();
        console.log("✅ เปิดตัวอย่าง PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    downloadPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        const fileName = `Statement_${this.statement.documentNo}_${this.statement.date}.pdf`;
        pdfMake.createPdf(docDefinition).download(fileName);
        console.log("✅ ดาวน์โหลด PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการดาวน์โหลด PDF: " + error.message);
      }
    },
  },
};
</script>

<style scoped>
.pdf-statement {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px 0;
}

.summary-box {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  display: inline-block;
  min-width: 300px;
}

.summary-box p {
  margin: 5px 0;
  font-size: 14px;
}

.summary-box .total {
  font-size: 18px;
  color: #d32f2f;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 2px solid #d32f2f;
}
</style>
